// src/components/Profile/AvatarSection.js
import React, { useState } from 'react'
import {
  Box,
  Avatar,
  IconButton,
  Tooltip,
  Typography,
  CircularProgress,
  Button
} from '@mui/material'
import { PhotoCamera } from '@mui/icons-material'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { storage, db } from '../../firebase'
import { doc, updateDoc } from 'firebase/firestore'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function AvatarSection({ userData, setUserData, setError, setSuccess }) {
  const { t } = useTranslation() // i18n Hook

  const [avatar, setAvatar] = useState(null)
  const [avatarPreview, setAvatarPreview] = useState(userData.avatarUrl || '')
  const [uploading, setUploading] = useState(false)

  const handleAvatarChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setAvatar(file)
      setAvatarPreview(URL.createObjectURL(file))
    }
  }

  const handleUpload = async () => {
    if (!avatar) return
    setUploading(true)
    try {
      const avatarRef = ref(storage, `avatars/${userData.uid}/${avatar.name}`)
      await uploadBytes(avatarRef, avatar)
      const avatarUrl = await getDownloadURL(avatarRef)
      const userDoc = doc(db, 'users', userData.uid)
      await updateDoc(userDoc, { avatarUrl })

      setUserData((prev) => ({ ...prev, avatarUrl }))
      setSuccess(t('profileAvatar.avatarUpdateSuccess')) // <-- Başarı mesajı
    } catch (err) {
      console.error('Avatar güncellenirken hata:', err)
      setError(t('profileAvatar.avatarUpdateError')) // <-- Hata mesajı
    } finally {
      setUploading(false)
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ textAlign: 'center' }}
    >
      <Tooltip title={t('profileAvatar.tooltipTitle')}>
        <label htmlFor="avatar-upload">
          <input
            accept="image/*"
            id="avatar-upload"
            type="file"
            style={{ display: 'none' }}
            onChange={handleAvatarChange}
          />
          <IconButton
            component="span"
            disableRipple
            sx={{
              position: 'relative',
              p: 0,
              borderRadius: '50%'
            }}
          >
            <Avatar
              src={avatarPreview}
              alt="User Avatar"
              sx={{
                width: 120,
                height: 120,
                boxShadow: '0 14px 36px rgba(15,23,42,0.45)',
                border: '3px solid rgba(255,255,255,0.95)',
                backgroundColor: 'rgba(148,163,184,0.2)'
              }}
            />
            <PhotoCamera
              sx={{
                position: 'absolute',
                bottom: 4,
                right: 4,
                bgcolor: 'primary.main',
                color: 'white',
                width: 28,
                height: 28,
                borderRadius: '50%',
                boxShadow: '0 10px 24px rgba(37,99,235,0.6)',
                p: 0.5
              }}
            />
          </IconButton>
        </label>
      </Tooltip>

      <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
        {t('profileAvatar.clickToUpdate')}
      </Typography>

      {avatar && (
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={uploading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 999,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.85rem',
              boxShadow: '0 12px 28px rgba(37,99,235,0.45)'
            }}
          >
            {uploading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t('profileAvatar.uploadBtn')
            )}
          </Button>
        </Box>
      )}
    </Box>
  )
}